module.exports = __webpack_public_path__ + "ce2caf5aada03ef56fb5e4b049d695ba.svg";